import { Box, Stack } from "@zenchef/styled-system/jsx";
import { PropsWithChildren } from "react";
import ContainerFooter, { FooterExposedProps } from "./ContainerFooter";
import { css, cx } from "@zenchef/styled-system/css";
import Title, { TitleExposedProps } from "./Title";
import { aromaSection } from "@zenchef/styled-system/recipes";
import Alert, { AlertProps } from "../Alert/Alert";

interface ContainerProps extends PropsWithChildren {
  className?: string;
  contentClassName?: string;
  title: TitleExposedProps | null;
  titleClassName?: string;
  footer?: FooterExposedProps;
  footerClassName?: string;
  alertProps?: AlertProps;
}

export default function Container({
  children,
  className,
  contentClassName,
  title,
  titleClassName,
  footer,
  footerClassName,
  alertProps,
}: ContainerProps) {
  const classes = aromaSection({
    withFooter: !!footer,
    titleAsContent: !!title,
  });

  return (
    <Box className={cx(classes.container, className)}>
      <Box className={cx(classes.content, contentClassName)}>
        {(() => {
          if (title && alertProps) {
            return (
              <Stack gap="gap.6" flexDir={{ base: "row", smDown: "column" }}>
                <Title
                  {...title}
                  className={cx(
                    classes.title,
                    css({ flexBasis: "50%" }),
                    titleClassName,
                  )}
                />
                <Alert {...alertProps} className={css({ flexBasis: "50%" })} />
              </Stack>
            );
          }

          if (title) {
            return (
              <Title {...title} className={cx(classes.title, titleClassName)} />
            );
          }

          if (alertProps) {
            return <Alert {...alertProps} />;
          }

          return null;
        })()}
        {children}
      </Box>
      {footer ? (
        <ContainerFooter
          {...footer}
          className={cx(classes.footer, footerClassName)}
        />
      ) : null}
    </Box>
  );
}
